export const PRINT_SCENES = {
  ONLINE_WASH: "online-wash",
  STORE_WASH: "store-wash",
  ONLINE_TOPIC: "online-topic",
  STORE_TOPIC: "store-topic",
  ONLINE_WAYBILL: "online-waybill",
};

export const SCENE_META = [
  {
    id: PRINT_SCENES.ONLINE_WASH,
    label: "线上水洗码",
    desc: "入厂分检、线上补打",
  },
  {
    id: PRINT_SCENES.STORE_WASH,
    label: "门店水洗码",
    desc: "门店分检、收衣",
  },
  {
    id: PRINT_SCENES.ONLINE_TOPIC,
    label: "线上总检码",
    desc: "工厂总检（线上单）",
  },
  {
    id: PRINT_SCENES.STORE_TOPIC,
    label: "门店总检码",
    desc: "工厂总检（门店单）",
  },
  {
    id: PRINT_SCENES.ONLINE_WAYBILL,
    label: "线上面单",
    desc: "出厂寄回快递面单",
  },
];

const STORAGE_KEY = "laundry_print_template_settings";

const WASH_FIELDS = {
  title: true,
  washCode: true,
  customer: true,
  channel: true,
  girdNumber: true,
  product: true,
  flaw: true,
  annex: true,
};

const STORE_WASH_FIELDS = {
  ...WASH_FIELDS,
  refundTag: true,
};

const ONLINE_TOPIC_FIELDS = {
  girdNumber: true,
  plant: true,
  channel: true,
  completeMark: true,
  refundTag: true,
  customer: true,
  product: true,
  quantity: true,
  annex: true,
  annexQtyGird: true,
  annexNames: true,
  phone: true,
  orderSn: true,
  factoryTime: true,
  inspectTime: true,
  barcode: true,
  barcodeText: true,
};

const STORE_TOPIC_FIELDS = {
  girdNumber: true,
  stageName: true,
  driver: true,
  channel: true,
  completeMark: true,
  refundTag: true,
  customer: true,
  product: true,
  quantity: true,
  annex: true,
  annexQtyGird: true,
  annexNames: true,
  phone: true,
  orderSn: true,
  sortingTime: true,
  inspectTime: true,
  barcode: true,
  barcodeText: true,
};

const WAYBILL_FIELDS = {
  hotline: true,
  expressType: true,
  barcode: true,
  waybillSn: true,
  route: true,
  coding: true,
  receiver: true,
  qrCode: true,
  sender: true,
  orderSn: true,
  quantity: true,
  girdNumber: true,
};

export const FIELD_OPTIONS = {
  [PRINT_SCENES.ONLINE_WASH]: [
    { key: "title", label: "工厂标题/日期" },
    { key: "washCode", label: "水洗码文字" },
    { key: "customer", label: "姓名/电话" },
    { key: "channel", label: "来源渠道" },
    { key: "girdNumber", label: "格架号" },
    { key: "product", label: "品名/件数" },
    { key: "flaw", label: "瑕疵" },
    { key: "annex", label: "附件" },
  ],
  [PRINT_SCENES.STORE_WASH]: [
    { key: "title", label: "门店标题/日期" },
    { key: "washCode", label: "水洗码文字" },
    { key: "customer", label: "寄件人/电话" },
    { key: "channel", label: "来源渠道" },
    { key: "girdNumber", label: "格架号" },
    { key: "refundTag", label: "退洗标记" },
    { key: "product", label: "品名/件数" },
    { key: "flaw", label: "瑕疵" },
    { key: "annex", label: "附件" },
  ],
  [PRINT_SCENES.ONLINE_TOPIC]: [
    { key: "girdNumber", label: "格架号(大字)" },
    { key: "plant", label: "工厂名称" },
    { key: "channel", label: "来源渠道" },
    { key: "completeMark", label: "齐字标记" },
    { key: "refundTag", label: "退洗/返洗" },
    { key: "customer", label: "客户姓名" },
    { key: "product", label: "品名" },
    { key: "quantity", label: "件数/序号" },
    { key: "annexQtyGird", label: "附件数量/格架号" },
    { key: "annexNames", label: "附件中文名称" },
    { key: "phone", label: "电话号码" },
    { key: "orderSn", label: "订单编号" },
    { key: "factoryTime", label: "入厂时间" },
    { key: "inspectTime", label: "总检时间" },
    { key: "barcode", label: "条码" },
    { key: "barcodeText", label: "条码文本" },
  ],
  [PRINT_SCENES.STORE_TOPIC]: [
    { key: "girdNumber", label: "格架号(大字)" },
    { key: "stageName", label: "门店名称" },
    { key: "driver", label: "司机姓名" },
    { key: "channel", label: "来源渠道" },
    { key: "completeMark", label: "齐字标记" },
    { key: "refundTag", label: "退洗/返洗" },
    { key: "customer", label: "寄件人" },
    { key: "product", label: "品名" },
    { key: "quantity", label: "件数" },
    { key: "annexQtyGird", label: "附件数量/格架号" },
    { key: "annexNames", label: "附件中文名称" },
    { key: "phone", label: "电话号码" },
    { key: "orderSn", label: "订单编号" },
    { key: "sortingTime", label: "分检时间" },
    { key: "inspectTime", label: "总检时间" },
    { key: "barcode", label: "条码" },
    { key: "barcodeText", label: "条码文本" },
  ],
  [PRINT_SCENES.ONLINE_WAYBILL]: [
    { key: "hotline", label: "客服热线/已验视" },
    { key: "expressType", label: "快递类型(标快)" },
    { key: "barcode", label: "运单条码" },
    { key: "waybillSn", label: "运单号" },
    { key: "route", label: "路由标签" },
    { key: "coding", label: "编码映射" },
    { key: "receiver", label: "收件人信息" },
    { key: "qrCode", label: "二维码" },
    { key: "sender", label: "寄件人信息" },
    { key: "orderSn", label: "订单编号" },
    { key: "quantity", label: "衣物数量" },
    { key: "girdNumber", label: "格架号" },
  ],
};

const DEFAULTS = {
  [PRINT_SCENES.ONLINE_WASH]: {
    pageWidth: "100mm",
    pageHeight: "20mm",
    htmlWidth: "377px",
    htmlHeight: "72px",
    defaultFontSize: "9pt",
    girdFontSize: "13pt",
    channelFontSize: "13pt",
    washBarcode: {
      top: "5mm",
      left: "3mm",
      width: "38mm",
      height: "10mm",
      previewText: "",
    },
    washCodeText: {
      top: "16.5mm",
      left: "2mm",
      width: "38mm",
      height: "3mm",
    },
    annexWashBarcode: {
      top: "5mm",
      left: "2mm",
      width: "40mm",
      height: "10mm",
      previewText: "",
    },
    barcode: { top: 20, left: "3mm", width: "130px", height: 38 },
    htmlLeft: { top: "1.2mm", left: "0mm", width: "40%", height: "100%" },
    htmlRight: { top: "1.2mm", left: "35mm", width: "60%", height: "100%" },
    annexBarcode: { top: 20, left: "2mm", width: "140px", height: 38 },
    annexHtmlRight: { top: "1.2mm", left: "40mm", width: "60%", height: "100%" },
    truncate: { title: 6, name: 4, channel: 5, flaw: 16, annexFlaw: 14 },
    channelWrap: "bracket",
    fields: { ...WASH_FIELDS },
  },
  [PRINT_SCENES.STORE_WASH]: {
    pageWidth: "100mm",
    pageHeight: "20mm",
    htmlWidth: "377px",
    htmlHeight: "72px",
    defaultFontSize: "9pt",
    girdFontSize: "13pt",
    channelFontSize: "11pt",
    washBarcode: {
      top: "5mm",
      left: "4mm",
      width: "36mm",
      height: "10mm",
      previewText: "",
    },
    washCodeText: {
      top: "16.5mm",
      left: "2mm",
      width: "38mm",
      height: "3mm",
    },
    annexWashBarcode: {
      top: "5mm",
      left: "4mm",
      width: "38mm",
      height: "10mm",
      previewText: "",
    },
    barcode: { top: 20, left: "4mm", width: "130px", height: 38 },
    htmlLeft: { top: "1.2mm", left: "0mm", width: "40%", height: "100%" },
    htmlRight: { top: "1.2mm", left: "38mm", width: "60%", height: "100%" },
    annexBarcode: { top: 20, left: "4mm", width: "130px", height: 38 },
    annexHtmlRight: { top: "1.2mm", left: "40mm", width: "60%", height: "100%" },
    truncate: { title: 5, name: 4, channel: 5, flaw: 16, annexFlaw: 14 },
    channelWrap: "md",
    fields: { ...STORE_WASH_FIELDS },
  },
  [PRINT_SCENES.ONLINE_TOPIC]: {
    pageWidth: "80mm",
    pageHeight: "80mm",
    htmlWidth: "300px",
    htmlHeight: "300px",
    defaultFontSize: "11pt",
    girdFontSize: "50pt",
    plantFontSize: "13pt",
    channelFontSize: "16pt",
    completeMarkFontSize: "28pt",
    completeMarkTop: "62px",
    completeMarkRight: "20px",
    htmlTop: "1mm",
    topicBarcode: {
      top: "60mm",
      left: "",
      width: "68mm",
      height: "20mm",
      textFontSize: 12,
      horient: 2,
      previewText: "",
    },
    barcodeJs: { width: 2.2, height: 65, fontSize: 12 },
    truncate: { name: 8, channel: 5, plant: 5 },
    channelWrap: "plain",
    topicRightLabels: { factoryTime: "入厂时间" },
    fields: { ...ONLINE_TOPIC_FIELDS },
  },
  [PRINT_SCENES.STORE_TOPIC]: {
    pageWidth: "80mm",
    pageHeight: "80mm",
    htmlWidth: "300px",
    htmlHeight: "300px",
    defaultFontSize: "11pt",
    girdFontSize: "42pt",
    stageFontSize: "14pt",
    driverFontSize: "10pt",
    channelFontSize: "16pt",
    completeMarkFontSize: "28pt",
    completeMarkTop: "52px",
    completeMarkRight: "20px",
    htmlTop: "1mm",
    topicBarcode: {
      top: "60mm",
      left: "",
      width: "56mm",
      height: "18mm",
      textFontSize: 14,
      horient: 2,
      previewText: "",
    },
    barcode: { top: 210, left: 50, width: 200, height: 70 },
    truncate: { name: 8, stage: 8, driver: 5, channel: 5 },
    channelWrap: "md",
    fields: { ...STORE_TOPIC_FIELDS },
  },
  [PRINT_SCENES.ONLINE_WAYBILL]: {
    pageWidth: "76mm",
    pageHeight: "130mm",
    htmlWidth: "277px",
    htmlHeight: "460px",
    defaultFontSize: "9pt",
    girdFontSize: "20pt",
    htmlTop: "5mm",
    htmlLeft: "0mm",
    barcodeJs: { width: 1.5, height: 45, fontSize: 16 },
    qrCode: { width: 100, height: 100, content: "waybillSn", previewText: "" },
    fields: { ...WAYBILL_FIELDS },
  },
};

function readStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

function writeStore(store) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}

function deepMerge(base, patch) {
  const result = { ...base };
  Object.keys(patch || {}).forEach((key) => {
    const val = patch[key];
    if (val && typeof val === "object" && !Array.isArray(val)) {
      result[key] = deepMerge(base[key] || {}, val);
    } else if (val !== undefined) {
      result[key] = val;
    }
  });
  return result;
}

export function getDefaultPrintTemplate(scene) {
  const defaults = DEFAULTS[scene];
  if (!defaults) {
    return null;
  }
  return JSON.parse(JSON.stringify(defaults));
}

export function hasCustomPrintTemplate(scene) {
  const store = readStore();
  return !!(store[scene] && Object.keys(store[scene]).length);
}

export function resolvePrintTemplate(scene) {
  const defaults = getDefaultPrintTemplate(scene);
  if (!defaults) {
    return null;
  }
  const saved = readStore()[scene];
  if (!saved) {
    return defaults;
  }
  const merged = deepMerge(defaults, saved);
  if (
    scene === PRINT_SCENES.STORE_TOPIC &&
    merged.truncate &&
    merged.truncate.name === 6
  ) {
    merged.truncate.name = 8;
  }
  return merged;
}

export function resolvePrintTemplateWithOverride(scene, override) {
  const base = resolvePrintTemplate(scene);
  if (!base || !override) {
    return base;
  }
  return deepMerge(base, override);
}

export function setPrintTemplate(scene, patch) {
  if (!DEFAULTS[scene]) {
    return { ok: false, reason: "invalid_scene" };
  }
  try {
    const store = readStore();
    store[scene] = deepMerge(store[scene] || {}, patch);
    writeStore(store);
    return { ok: true };
  } catch (err) {
    console.error("[printTemplateStorage] setPrintTemplate failed", err);
    return { ok: false, reason: "storage_error" };
  }
}

export function resetPrintTemplate(scene) {
  const store = readStore();
  delete store[scene];
  writeStore(store);
}

export function truncateText(value, maxLen, fallback = "") {
  if (value == null || value === "") {
    return fallback;
  }
  const str = String(value);
  if (!maxLen || maxLen <= 0) {
    return str;
  }
  return str.length > maxLen ? str.substring(0, maxLen) : str;
}

/** 水洗码衣物名称最多 4 字（不在模板配置中暴露） */
export const WASH_PRODUCT_NAME_LIMIT = 4;

export function truncatePrintProductName(value, tpl, scene) {
  if (value == null || value === "") {
    return "";
  }
  const str = String(value);
  if (
    scene === PRINT_SCENES.ONLINE_WASH ||
    scene === PRINT_SCENES.STORE_WASH
  ) {
    return truncateText(str, WASH_PRODUCT_NAME_LIMIT, str);
  }
  const nameLimit =
    tpl && tpl.truncate && tpl.truncate.name > 0 ? tpl.truncate.name : 8;
  return truncateText(str, nameLimit, str);
}

export function formatChannelLabel(name, wrap, maxLen) {
  const nameLimit = maxLen != null && maxLen > 0 ? maxLen : 5;
  const text = truncateText(name, nameLimit, "");
  if (!text) {
    return "";
  }
  if (wrap === "md") {
    return `MD-${text}`;
  }
  if (wrap === "bracket") {
    return `【${text}】`;
  }
  return text;
}

export function isFieldVisible(tpl, key) {
  if (!tpl || !tpl.fields || tpl.fields[key] === undefined) {
    return true;
  }
  return !!tpl.fields[key];
}

/** 总检附件：数量+格架号（兼容旧字段 annex） */
export function isTopicAnnexQtyGirdVisible(tpl) {
  const fields = tpl && tpl.fields;
  if (!fields) {
    return true;
  }
  if (fields.annexQtyGird !== undefined) {
    return !!fields.annexQtyGird;
  }
  if (fields.annex !== undefined) {
    return !!fields.annex;
  }
  return true;
}

/** 总检附件：中文名称（兼容旧字段 annex） */
export function isTopicAnnexNamesVisible(tpl) {
  const fields = tpl && tpl.fields;
  if (!fields) {
    return true;
  }
  if (fields.annexNames !== undefined) {
    return !!fields.annexNames;
  }
  if (fields.annex !== undefined) {
    return !!fields.annex;
  }
  return true;
}

export function isTopicAnnexRowVisible(tpl) {
  return isTopicAnnexQtyGirdVisible(tpl) || isTopicAnnexNamesVisible(tpl);
}

export function applyWashLodop(LODOP, tpl, { code, printName, leftHtml, rightHtml }) {
  LODOP.SET_PRINT_PAGESIZE(1, tpl.pageWidth, tpl.pageHeight);
  LODOP.SET_PRINTER_INDEX(printName);
  const bc = tpl.barcode;
  LODOP.ADD_PRINT_BARCODE(bc.top, bc.left, bc.width, bc.height, "128Auto", code);
  LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
  LODOP.SET_PRINT_STYLEA(0, "BarcodeWidthFix", 1);
  const hl = tpl.htmlLeft;
  const hr = tpl.htmlRight;
  LODOP.ADD_PRINT_HTM(hl.top, hl.left, hl.width, hl.height, leftHtml);
  LODOP.ADD_PRINT_HTM(hr.top, hr.left, hr.width, hr.height, rightHtml);
}

export function applyAnnexLodop(
  LODOP,
  tpl,
  { codes, printName, htmlLeftEls, htmlRightEls },
) {
  LODOP.SET_PRINT_PAGESIZE(1, tpl.pageWidth, tpl.pageHeight);
  LODOP.SET_PRINTER_INDEX(printName);
  const bc = tpl.annexBarcode;
  const hl = tpl.htmlLeft;
  const hr = tpl.annexHtmlRight;

  for (let i = 0; i < codes.length; i++) {
    if (i > 0) {
      LODOP.NEWPAGE();
    }
    LODOP.ADD_PRINT_BARCODE(bc.top, bc.left, bc.width, bc.height, "128Auto", codes[i]);
    LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0);
    LODOP.SET_PRINT_STYLEA(0, "BarcodeWidthFix", 1);
    LODOP.ADD_PRINT_HTM(hl.top, hl.left, hl.width, hl.height, htmlLeftEls[i].innerHTML);
    LODOP.ADD_PRINT_HTM(hr.top, hr.left, hr.width, hr.height, htmlRightEls[i].innerHTML);
  }
}

export function applyTopicLodop(LODOP, tpl, { code, printName, html, useLodopBarcode }) {
  LODOP.SET_PRINT_PAGESIZE(1, tpl.pageWidth, tpl.pageHeight);
  if (useLodopBarcode && tpl.barcode) {
    const bc = tpl.barcode;
    LODOP.ADD_PRINT_BARCODE(bc.top, bc.left, bc.width, bc.height, "128Auto", code);
  }
  LODOP.ADD_PRINT_HTM(tpl.htmlTop, 0, "100%", "100%", html);
  LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
  LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);
  LODOP.SET_PRINTER_INDEX(printName);
  LODOP.SET_PRINT_COPIES(1);
}

export function resolveWaybillQrText(item, tpl) {
  const qr = (tpl && tpl.qrCode) || {};
  if (qr.previewText) {
    return qr.previewText;
  }
  if (qr.content === "orderSn") {
    return item.orderSn || "";
  }
  return item.backDeliverySn || "";
}

export function applyWaybillLodop(LODOP, tpl, { printName, html }) {
  LODOP.SET_PRINT_PAGESIZE(1, tpl.pageWidth, tpl.pageHeight);
  LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
  LODOP.ADD_PRINT_HTM(tpl.htmlTop, tpl.htmlLeft, "100%", "100%", html);
  LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
  LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);
  LODOP.SET_PRINTER_INDEX(printName);
  LODOP.SET_PRINT_COPIES(1);
}

export const PAGE_SIZE_PRESETS = [
  { label: "100 × 20 mm（水洗码）", width: "100mm", height: "20mm" },
  { label: "100 × 25 mm", width: "100mm", height: "25mm" },
  {
    label: "80 × 80 mm（总检码）",
    width: "80mm",
    height: "80mm",
    htmlWidth: "300px",
    htmlHeight: "300px",
  },
  {
    label: "80 × 60 mm（总检码）",
    width: "80mm",
    height: "60mm",
    htmlWidth: "300px",
    htmlHeight: "225px",
  },
  {
    label: "60 × 40 mm（总检码）",
    width: "60mm",
    height: "40mm",
    htmlWidth: "300px",
    htmlHeight: "300px",
  },
  { label: "76 × 130 mm（面单）", width: "76mm", height: "130mm" },
];
